<template>
    <v-container >
        <template v-if="cleaning">
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <h1 class="mb-3 heading deep-purple--text text--accent-3">Mazgāšana <span v-if="cleaning.cleaned_item.type === 'Konteiners'">konteineram  {{cleaning.cleaned_item.regNr}}</span>
                        <span v-else> cisternai  {{cleaning.cleaned_item.regNr}}</span>
                    </h1>
                </v-flex>

                <v-spacer></v-spacer>

                <v-flex v-if="!showForm" xs2 sm1 class="pt-2 text-xs-right">
                    <v-tooltip top>
                        <v-btn  @click="showUpdateCleaningForm" small outline fab color="deep-purple" slot="activator">
                            <v-icon >edit</v-icon>
                        </v-btn>
                        <span>Labot mazgāšanu</span>
                    </v-tooltip>
                </v-flex>

            </v-layout>

            <update-cleaning v-if="showForm" :cleaning="cleaning"></update-cleaning>


            <v-layout row wrap>
                <v-flex xs12 sm6 xl4>
                    <v-card flat class="ma-2">

                        <v-toolbar flat color="white">
                            <v-toolbar-title class="subheading deep-purple--text text--accent-3">Info</v-toolbar-title>
                        </v-toolbar>

                        <v-divider class="deep-purple accent-3"></v-divider>

                        <v-layout row wrap>
                            <v-flex xs6>
                                <v-card-text>
                                    <div class="caption grey--text">Mazgāšanas datums</div>
                                    <div class="mb-2">{{cleaning.cleaning_date}}</div>
                                    <div class="caption grey--text">Sākuma laiks</div>
                                    <div v-if="cleaning.start_time" class="mb-2">{{cleaning.start_time}}</div>
                                    <div v-else class="mb-2">Nav norādīts</div>
                                    <div class="caption grey--text">Beigu laiks</div>
                                    <div v-if="cleaning.end_time" class="mb-2">{{cleaning.end_time}}</div>
                                    <div v-else class="mb-2">Nav norādīts</div>
                                    <div class="caption grey--text">Vilcējs</div>
                                    <div v-if="cleaning.truck" class="mb-2">{{cleaning.truck.reg_nr}}</div>
                                    <div v-else class="mb-2">Nav norādīts</div>
                                </v-card-text>
                            </v-flex>

                            <v-flex xs6>
                                <v-card-text>
                                    <div class="caption grey--text">Krava</div>
                                    <div class="mb-2">{{cleaning.cargo.name}}</div>
                                    <div class="caption grey--text">UN numurs</div>
                                    <div v-if="cleaning.cargo.un_nr" class="mb-2">{{cleaning.cargo.un_nr}}</div>
                                    <div v-else class="mb-2">Nav norādīts</div>
                                    <div class="caption grey--text">Klients</div>
                                    <div class="mb-2">{{cleaning.customer.name}}</div>
                                    <template v-if="cleaning.cleaned_item.type === 'Konteiners'">
                                        <div class="caption grey--text">Piekabe</div>
                                        <div v-if="cleaning.trailer" class="mb-2">{{cleaning.trailer.reg_nr}}</div>
                                        <div v-else class="mb-2">Nav norādīts</div>
                                    </template>
                                </v-card-text>
                            </v-flex>

                        </v-layout>


                    </v-card>
                </v-flex>

                <v-flex xs12 sm6 xl4>
                    <v-card flat class="ma-2">

                        <v-toolbar flat color="white">
                            <v-toolbar-title class="subheading deep-purple--text text--accent-3">Mazgāšana</v-toolbar-title>
                        </v-toolbar>

                        <v-divider class="deep-purple accent-3"></v-divider>

                        <v-layout row wrap class="mb-2 mt-2">
                            <v-flex xs6 sm4 v-for="option in cleaning.cleaningOptions" :key="option.id" class="px-3 pt-1">
                                <div class="caption grey--text">Darbība</div>
                                <div class="">{{option.display_name}}</div>
                            </v-flex>
                        </v-layout>

                        <v-layout row wrap>
                            <v-flex v-if="cleaning.additional_services" xs12>
                                <v-card-text>
                                    <div class="caption grey--text">Papildus info</div>
                                    <div class="mb-2">{{cleaning.additional_services}}</div>
                                </v-card-text>
                            </v-flex>

                            <v-flex xs6>
                                <v-card-text>
                                    <div class="caption grey--text">Izmazgātās sekcijas</div>
                                    <div class="mb-2">{{cleaning.tank_compartments}}</div>
                                    <div class="caption grey--text">Mazgāšanas programma</div>
                                    <div v-if="cleaning.leftovers" class="mb-2">{{cleaning.cleaning_program ? cleaning.cleaning_program.program_number : ''}}</div>
                                    <div v-else class="mb-2">Nav norādīts</div>
                                </v-card-text>
                            </v-flex>

                            <v-flex xs6>
                                <v-card-text>
                                    <div class="caption grey--text">Iekšējais nr.</div>
                                    <div v-if="cleaning.cleaning_order_nr" class="mb-2">{{cleaning.cleaning_order_nr}}</div>
                                    <div v-else class="mb-2">Nav norādīts</div>
                                    <div class="caption grey--text">Preču pārpalikumi</div>
                                    <div v-if="cleaning.leftovers" class="mb-2">{{cleaning.leftovers}}</div>
                                    <div v-else class="mb-2">Nav norādīts</div>
                                </v-card-text>
                            </v-flex>

                        </v-layout>

                    </v-card>

                </v-flex>

                <v-flex xs12 sm6 xl4>
                    <v-card flat class="ma-2">

                        <v-toolbar flat color="white">
                            <v-toolbar-title class="subheading deep-purple--text text--accent-3">Sertifikāts</v-toolbar-title>
                        </v-toolbar>

                        <v-divider class="deep-purple accent-3"></v-divider>

                        <template  v-if="!showCertificateForm">
                            <v-card-text>
                                <template  v-if="cleaning.certificate">
                                    <v-layout row wrap>
                                        <v-flex xs11>
                                            <div class="caption grey--text">Sertifikāta nr</div>
                                            <div class="mb-2">{{cleaning.certificate.certificate_nr}}</div>
                                        </v-flex>
                                        <v-flex xs1>
                                            <v-tooltip top>
                                                <v-btn icon @click="deleteCertificate(cleaning.certificate.id)" flat small slot="activator">
                                                    <v-icon color="grey">delete</v-icon>
                                                </v-btn>
                                                <span>Dzēst sertifikātu</span>
                                            </v-tooltip>
                                        </v-flex>
                                    </v-layout>
                                </template>
                                <template v-else>
                                    <div class="text-xs-center">Spied te, lai pievienotu sertifikātu</div>
                                    <v-flex class="text-xs-center">
                                        <v-btn flat icon outline @click="showCertForm()" color="green">
                                            <v-icon >add</v-icon>
                                        </v-btn>
                                    </v-flex>
                                </template>
                            </v-card-text>
                        </template>

                        <template v-if="showCertificateForm">
                            <v-card-text >
                                <v-form ref="form">
                                    <v-layout row wrap>
                                        <v-flex xs9>
                                            <v-text-field
                                                    class="pa-3"
                                                    v-model="certificateNr"
                                                    label="Sertifikāta nr"
                                                    color="deep-purple accent-3"
                                                    :rules="formRules"
                                                    required
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs1 class="pt-3">
                                                <v-btn small fab flat @click="hideCertForm" dark color="deep-orange lighten-1">
                                                    <v-icon dark >block</v-icon></v-btn>
                                        </v-flex>
                                        <v-flex xs1 class="pt-3">
                                                <v-btn small flat fab @click="addCertificate" dark color="green accent-4">
                                                    <v-icon dark >check_circle</v-icon>
                                                </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-form>
                            </v-card-text>
                        </template>


                    </v-card>
                </v-flex>

            </v-layout>


        <v-snackbar
                v-model="snackbar"
                :color="color"
                :timeout="timeout"
                auto-height
                right
        >
            {{ text }}
            <v-btn dark
                   flat
                   @click="snackbar = false"
            >X</v-btn>
        </v-snackbar>
        </template>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'
    import UpdateCleaning from "../components/UpdateCleaning.vue";

    export default {
        name: "Cleaning",
        components: {UpdateCleaning},
        data: () => ({
            snackbar: false,
            color: '',
            timeout: 2000,
            text: '',
            showAdditionalInfoForm: false,
            showCertificateForm: false,
            certificateNr: '',
            formRules: [
                v => !!v || 'Šis lauks ir obligāts',
            ],
        }),
        created() {
            this.hideCertForm()
            this.$store.dispatch('hideUpdateCleaningForm')
            this.$store.dispatch('getSingleCleaning', this.$route.params.id)
        },
        computed: {
            ...mapGetters({
                cleaning: 'cleaning',
                showForm: 'showUpdateCleaningForm'
            })
        },
        methods: {
            showUpdateCleaningForm(){
                this.$store.dispatch('showUpdateCleaningForm')
            },
            showCertForm(){
                this.showCertificateForm = true
            },
            hideCertForm(){
                this.showCertificateForm = false
            },
            hideUpdateCleaningForm(){
                this.$store.dispatch('hideUpdateCleaningForm')
            },
            deleteCleaning(cleaningId){
                if(confirm('Vai esi drošs?')){
                    this.$Progress.start()
                    this.$store.dispatch('deleteCleaning', cleaningId)
                    this.snackbar = true
                    this.color = 'red'
                    this.text = 'Mazgāšana dzēsta'
                }
            },
            addCertificate() {
                if (this.$refs.form.validate()) {
                    this.$store.dispatch('addCertificate', this.certificateNr)
                    this.hideCertForm()
                    this.snackbar = true
                    this.color = 'green'
                    this.text = 'Sertifikāts pievienots'
                }
            },
            deleteCertificate(certificateId){
                if(confirm('Vai esi drošs?')){
                    this.$Progress.start()
                    this.$store.dispatch('deleteCertificate', certificateId)
                    this.snackbar = true
                    this.color = 'red'
                    this.text = 'Sertifikāts dzēsts'
                }
            },
        }
    }
</script>

<style scoped>

</style>